import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {UtilService} from '../../services/util.service';
import {ValidationConstraint} from '../../domain/validation-constraint';
import * as _ from 'lodash';

@Component({
    selector: 'app-custom-input-date',
    templateUrl: './custom-input-date.component.html',
    styleUrls: ['./custom-input-date.component.scss']
})
export class CustomInputDateComponent implements OnInit, OnChanges {

    @Input() result: any;
    @Input() styleClass: string;
    @Input() labelClass: string;
    @Input() required: boolean;
    @Input() errors: object;
    @Input() modelPath: string;
    @Input() label: string;
    @Input() validationConstraints: ValidationConstraint[];
    @Input() disabled: boolean;

    @ViewChild('frm', { static: true }) form: any;

    maxDate = new Date();

    public name: string;

    public fieldValidationConstraints: ValidationConstraint[];

    @Output() resultChange = new EventEmitter();

    public error: string;

    constructor() {
    }

    ngOnInit() {
        this.error = UtilService.getObjByPath(this.errors, this.modelPath);
        this.disabled = this.disabled || false;
        if (this.validationConstraints !== null && this.modelPath) {
            this.fieldValidationConstraints = _.filter(this.validationConstraints, ['field', this.modelPath]);
        }
        this.name = 'control';
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.errors !== undefined) {
            this.error = UtilService.getObjByPath(this.errors, this.modelPath);
            if (this.form.form.controls[this.name] && this.error) {
                this.form.form.controls[this.name].markAsTouched(true);
                this.form.form.controls[this.name].setErrors({backend: {someProp: 'some message'}});
            }
        }
        if (!this.error && this.form.form.controls[this.name]) {
            this.form.form.controls[this.name].markAsUntouched(true);
        }
    }

    onModelChanged($event) {
        this.resultChange.emit($event);
    }

}
